module.exports = __webpack_public_path__ + "img/ic_digital_camera_black.49d70ff2.svg";